export default {
  units: [],
  unitCode: {},

  wareCategories: [],
  wareCategoryCode: null,

  wares: [],
  ware: {},
  wareCode: null,

  commodityCategories: [],
  commodityCategoryCode: null,

  commodities: [],
  commoditiesTotalCount: 0,
  commodity: {},
  commodityCode: null,
  commodityInfo: {},
  commodityNavigation: {},
  commodityBySearch: {},

  shelfs: [],
  shelfCode: null,

  unitCoefficients: [],

  commodityBarcodes: [],

  commodityUnitCounts: [],

  commodityImages: [],

  commodityAttachments: [],
  commodityAttachment: {},

  commodityFeatures: [],
  commodityFeatureCode: null,

  wareVoucherTypes: [],
  wareVoucherType: {},
  wareVoucherTypeCode: {},

  additionalCommodityParameters: [],

  parameterValues: [],

  tempReceipts: [],
  tempReceipt: {},
  tempReceiptCode: null,
  tempReceiptSerial: null,
  tempReceiptId: null,
  tempReceiptCreateResult: null,
  tempReceiptNavigation: {},
  tempReceiptCartable: [],
  tempReceiptExitCartable: [],

  receipts: [],
  receipt: {},
  receiptCode: null,
  receiptSerial: null,
  receiptNavigation: {},
  receiptCartable: [],
  receiptCheckDelete: {},
  receiptCheckUpdate: {},
  readBuyRequestByCommodity: [],
  readBuyRequestByCode: [],
  receiptByBarcode: {},
  receiptId: null,
  receiptCreateResult: null,
  receiptManagementCartable: [],
  receiptVoucher: [],

  receiptAttachments: [],

  drafts: [],
  draft: {},
  draftCode: null,
  draftSerial: null,
  draftNavigation: {},
  draftCartable: [],
  draftCheckCreate: [],
  draftCheckUpdate: {},
  draftId: null,
  draftCreateResult: null,
  draftVoucher: [],
  readDraftRequestByCode: [],

  draftAttachments: [],

  draftRequests: [],
  draftRequest: {},
  draftRequestId: null,
  draftRequestCreateResult: null,
  draftRequestCode: null,
  draftRequestSerial: null,
  draftRequestNavigation: {},
  draftRequestCartable: [],
  draftRequestCheckCreate: {},
  draftRequestCheckUpdate: {},

  draftManagementCartable: [],

  numeralCirculation: [],
  rialCirculation: [],

  receiptConfirmCartable: [],

  receiptUnConfirmCartable: [],

  draftConfirmCartable: [],

  draftValue: {},

  draftUnConfirmCartable: [],
  numeralCardex: [],
  rialCardex: [],
  circulationCommodity: [],

  inventoryDeduction: [],

  inventorySummary: [],
  inventorySummaryDetail: [],

  commoditySleep: [],

  commodityCirculation: {},

  negativeCommodity: [],

  sortSerialReceipt: false,

  transferCommodities: [],
  transferCommodity: {},
  transferCommodityCode: null,
  transferCommodityCartable: [],

  wareDocument: [],
  wareFinancialDocument: [],

  numeralInventory: [],
  rialInventory: [],

  warehousings: [],
  warehousing: {},
  warehousingId: null,
  warehousingCreateResult: null,
  warehousingCommodities: [],
  warehousingContradictions: [],
  warehousingTag: {},
  warehousingCommodityByWare: [],
  warehousingCommodityBatches: [],

  commodityBatches: [],

  userLimitWares: [],

  reqBuys: [],
  reqBuy: {},
  reqBuyId: null,
  reqBuyCreateResult: null,
  reqBuyCode: null,
  reqBuyNavigation: {},

  notYetBuyers: [],

  reqBuyCartable: [],

  packageTypes: [],
  packageTypeCode: null,

  boms: [],
  bom: {},
  bomCode: null,
  bomCommodities: [],

  commodityInventoryWare: [],

  receiptNotes: [],
  draftsNotes: [],

  buyTypes: [],
  buyTypeCode: null,

  receiptVerificationCartable: [],
  draftVerificationCartable: [],

  settings: [],

  cartableLog: [],
  printLink: {},

  commodityGroupConfigs: [],

  services: [],
  service: {},
  serviceSerial: null,

  serviceGroups: [],
  serviceGroupCode: null,
};
